import { defineStore } from 'pinia';
import Helper from '@/helpers/helper';
import ErrorHelper from '../helpers/errorManagerhelaper';
import Swal from 'sweetalert2';


export const useWalletStore = defineStore('wallets', {
    state: () => ({
        list: undefined,
        details: [],
        info: null,
        errors: [],
    }),
    actions: {
        setData(data) {
            this.list = data
        },

        addOne(newOne) {
            this.list ??= [];
            this.list.unshift(newOne)
        },

        removeOne(deleted) {
            this.list ??= [];
            this.list = this.list.filter(t => t.id != deleted.id) 
        },
        updateOne(updated) {
            this.list ??= [];
            const index = this.list.findIndex(t => t.id === updated.id)
            if (index !== -1) {
                this.list[index] = updated
            }
        },
     async  loadFromApi(londing = false) {
         try {

            if(londing){
                    Swal.showLoading();
                }
                const route = 'wallets'
                const response = await fetch(Helper.route(route), Helper.requestOptionsJSON())

                if (!response.ok) {
                    const error = await ErrorHelper.handleApiError(response);
                    ErrorHelper.showError(error);
                    return;
                }

                const data = await response.json()
                this.list = data;

                if(londing){
                    Swal.close();
                }
                return data;
            } catch (error) {
                const normalizedError = ErrorHelper.handleUnexpectedError(error);
                ErrorHelper.showError(normalizedError);
                throw normalizedError;
            }
        },
    
  async  createItem(body, ) {
       try {
            Swal.showLoading(null);
            const route = "wallets";
            const response = await fetch(Helper.route(route), Helper.requestOptionsJSON("POST", body))

            if (!response.ok) {
                const error = await ErrorHelper.handleApiError(response);
                ErrorHelper.showError(error);
                return;
            }

            const resp = response.json();
            this.addOne(resp)

            Swal.fire("Wallet !", "Wallet successfully created", "success");

        } catch (error) {
                const normalizedError = ErrorHelper.handleUnexpectedError(error);
                ErrorHelper.showError(normalizedError);
                throw normalizedError;
        }
    },

  async  editItem(id, body) {
        try {

            Swal.showLoading(null);

            const route = "wallets/" + id;
            const response = await fetch(Helper.route(route), Helper.requestOptionsJSON("PUT", body))

            if (!response.ok) {
                const error = await ErrorHelper.handleApiError(response);
                ErrorHelper.showError(error);
                return;
            }

            const resp = response.json();
            this.updateOne(resp)

            Swal.fire("Wallet !", "Wallet successfully updated", "success");

        } catch (error) {
                const normalizedError = ErrorHelper.handleUnexpectedError(error);
                ErrorHelper.showError(normalizedError);
                throw normalizedError;
        }


    },

  
    async  deleteItem(id) {
        try {

            Swal.showLoading(null);

            const route = "wallets/" + id;
            const response = await fetch(Helper.route(route), Helper.requestOptionsJSON("DELETE"))

            if (!response.ok) {
                const error = await ErrorHelper.handleApiError(response);
                ErrorHelper.showError(error);
                return;
            }

            this.removeOne(id)

            Swal.fire("Wallet !", "Method successfully removed", "success");

        } catch (error) {
                const normalizedError = ErrorHelper.handleUnexpectedError(error);
                ErrorHelper.showError(normalizedError);
                throw normalizedError;
        }


    },
},
    persist: {
        storage: sessionStorage,
        key: `${Helper.env}__wallets`
        
    },
})
